const formatTime = (iso: string): string => {
  try {
    return new Date(iso).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } catch {
    return '';
  }
};

/**
 * Human text for the time left on a reservation, or null when the equipment
 * has no expected time. Nothing hands it back on its own: past the expected
 * time it stays with the participant until they scan it again or staff
 * return it, so the text then asks them to.
 */
export function describeTimeLeft(expiresAt: string | null | undefined, now: number): string | null {
  if (!expiresAt) return null;
  const end = new Date(expiresAt).getTime();
  if (Number.isNaN(end)) return null;
  const minutes = Math.ceil((end - now) / 60_000);
  if (minutes <= 0) return `Tempo previsto até às ${formatTime(expiresAt)} · leia o QR para devolver`;
  return `Devolver até às ${formatTime(expiresAt)} · ${minutes} min restantes`;
}
